<template>
  <div>
    <div class="modal fade" id="captcha" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <span>
                <svg class="icon">
                  <use xlink:href="#icon-close"></use>
                </svg>
              </span>
            </button>
          </div>

          <div class="modal-body">
            <spinner :show="getCaptchaCodeLoading" class="spinner-component"></spinner>
            <div v-show="!getCaptchaCodeLoading" class="form-content">
              <p class="captcha-image text-center">
                <spinner :show="reloading"></spinner>
                <img :src="captcha_img" alt="captcha" @click="changeCaptcha" v-show="!reloading">
              </p>
              <div class="captcha-text form-group">
                <input type="text" name="captcha" v-model="captchaCode"
                       :placeholder="$t('verificationCode')" v-validate="'required'"
                       @blur="captchaBlur" @focus="captchaChange"
                       @keyup.enter="submit" @input="captchaChange">
                <div class="error-info">
                  <p v-if="captchaError">
                    <span v-if="errors.first('captcha')">{{errors.first('captcha')}}</span>
                    <span v-else="invalidCode">{{ captchaErrorMessage }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer text-center">
            <button v-show="!captchaSubmitLoading" @click="submit">{{$t('submitInfo')}}</button>
            <spinner :show="captchaSubmitLoading" class="spinner"></spinner>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/reset-modal";

  .modal-dialog {
    @include modal-dialog($height: 3.6rem, $phone-height: 3.6rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.8rem) 0 0 -45% !important;
    }
  }

  .modal-body {
    .form-content {
      max-width: 3rem;
      margin: 0 auto;
    }
    .spinner-component {
      margin: .9rem auto 0 auto;
    }
    .captcha-image {
      margin: .4rem auto .6rem auto;
      height: .4rem;
      img {
        width: 1.4rem;
        cursor: pointer;
      }
      .sk-chasing-dots {
        margin: 0 auto;
        width: .3rem;
        height: .3rem;
      }
    }
    input::-ms-clear {
      display: none;
    }
    input::-ms-reveal {
      display: none;
    }
  }

  .modal-footer {
    position: absolute;
    bottom: .4rem;
    left: 50%;
    width: 2.4rem;
    margin: 0 0 0 -1.2rem;
    button {
      @include modal-button();
    }
  }

</style>

<script>
  import Spinner from '../../components/Spinner.vue'
  import {mapState} from 'vuex'
  import locales from './lang'
  import $ from 'jquery'

  export default {
    name: 'captcha',
    components: {
      Spinner
    },
    locales,
    props: {
      getCaptchaCodeLoading: {type: Boolean},
      invalidCode: {type: Boolean},
      captchaSubmitLoading: {type: Boolean},
      phoneNumber: {type: String}
    },
    data: function () {
      return {
        captchaCode: '',
        reloading: false,
        captchaError: false,
        captchaErrorMessage: ''
      }
    },
    computed: {
      ...mapState({
        captcha_img: state => state.captcha.captcha_img
      })
    },
    watch: {
      invalidCode() {
        if (this.invalidCode) {
          this.captchaErrorMessage = this.$t('captchaError')
        }
      },
      getCaptchaCodeLoading() {
        if (!this.getCaptchaCodeLoading) {
          this.captchaError = false
          this.captchaCode = ''
        }
      }
    },
    mounted() {
      let _this = this
      $('#captcha').on('hidden.bs.modal', function () {
        _this.captchaCode = ''
        _this.captchaError = false
      })
      $('#captcha').on('show.bs.modal', function () {
        $('body').css({position: 'fixed', width: '100%'})
      })
      $('#captcha').on('hide.bs.modal', function () {
        $('body').css({position: '', width: ''})
      })
    },
    methods: {
      captchaBlur() {
        this.captchaErrorMessage = ''
        this.captchaError = true
      },
      captchaChange() {
        this.captchaErrorMessage = ''
        this.captchaError = false
      },
      changeCaptcha() {
        this.captchaCode = ''
        this.reloading = true
        this.captchaError = false
        this.$store.dispatch('getCaptchaLink', this.phoneNumber).then((code) => {
          if (code === 0) {
            this.reloading = false
          }
        })
      },
      submit() {
        this.$validator.validateAll().then(success => {
          if (!success) return
          this.captchaError = true
          this.$emit('verification', this.captchaCode)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Captcha.vue?6acb57b9